import React, { useState } from 'react';
import './Feedback.css';
import { API_BASE_URL } from '../config';
import { useToast } from '../contexts/ToastContext';

interface FeedbackProps {
  user: any;
}

const Feedback: React.FC<FeedbackProps> = ({ user }) => {
  const [email, setEmail] = useState(user.email || '');
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showToast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!feedback.trim()) {
      showToast('Please enter your feedback', 'error');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user.id,
          email: email.trim() || user.email || '',
          feedback: feedback.trim(),
        }),
      });

      if (response.ok) {
        showToast('Thank you for your feedback!', 'success');
        setFeedback('');
      } else {
        const errorData = await response.json();
        showToast(errorData.detail || 'Failed to submit feedback', 'error');
      }
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      showToast('Failed to submit feedback. Please try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="feedback-page">
      <div className="feedback-content">
        <h1>Give Feedback</h1>

        <div className="feedback-intro">
          <p>
            We really appreciate all feedback! Your input helps us make Baby Sleep Tracker
            better for all parents.
          </p>
          <p>
            Whether you've found a bug, have a feature suggestion, or just want to share your
            experience - we'd love to hear from you.
          </p>
        </div>

        <form className="feedback-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              disabled={isSubmitting}
            />
            <span className="form-hint">
              Optional - only if you'd like us to respond
            </span>
          </div>

          <div className="form-group">
            <label htmlFor="feedback">Your Feedback *</label>
            <textarea
              id="feedback"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Tell us what you think..."
              rows={8}
              disabled={isSubmitting}
              required
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
            disabled={isSubmitting || !feedback.trim()}
          >
            {isSubmitting ? 'Sending...' : 'Send Feedback'}
          </button>
        </form>

        <div className="feedback-footer">
          <p>
            You can also reach us directly at <a href="mailto:hello@simplebabysleep.com">hello@simplebabysleep.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
